import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type ServiceDashboardMessages = SidebarMessages &
  ActionButtonMessages & {
    pageTitle: string;
    pageSubtitle: string;
    breadCrumbTitle: string;
    operationalBreadCrumb: string;
    refreshButton: string;
    applyFiltersButton: string;
    fullscreenButton: string;
    lastUpdatedLabel: string;
    liveLabel: string;
    realtimeLabel: string;
    todayLabel: string;
    filtersButton: string;
    clearFiltersButton: string;
    sectionPulseTitle: string;
    sectionPulseCaption: string;
    sectionSlaTitle: string;
    sectionSlaCaption: string;
    sectionQueuesTitle: string;
    sectionQueuesCaption: string;
    sectionDistributionTitle: string;
    sectionDistributionCaption: string;
    sectionTrendTitle: string;
    sectionTrendCaption: string;
    totalLabel: string;
    autoRefreshHint: string;
    autoRefreshLabel: string;
    queueFilter: string;
    tagFilter: string;
    workflowFilter: string;
    activeConversationsTitle: string;
    newConversationsTitle: string;
    closedConversationsTitle: string;
    unansweredConversationsTitle: string;
    unreadMessagesTitle: string;
    frtTitle: string;
    slaTitle: string;
    tmaTitle: string;
    backlogTitle: string;
    conversationsByQueueTitle: string;
    queueCapacityTitle: string;
    conversationsByWorkflowTitle: string;
    conversationsByAttendantTitle: string;
    unreadByQueueTitle: string;
    aiVsHumanTitle: string;
    conversationsByHourTitle: string;
    attendantsLabel: string;
    openConversationsLabel: string;
    conversationsPerAttendantLabel: string;
    conversationsPerAttendantUnit: string;
    conversationsTitle: string;
    interactionsTitle: string;
    averageInteractionsPerConversationTitle: string;
    attendantPerformanceTitle: string;
    attendantPerformanceSubtitle: string;
    monthlyAttendantsTitle: string;
    attendantHeader: string;
    totalHeader: string;
    monthColumn: string;
    attendantColumn: string;
    attendantCountColumn: string;
    totalColumn: string;
    today: string;
    currentMonth: string;
    currentYear: string;
    lastDay: string;
    lastMonth: string;
    lastYear: string;
    notFoundAlt: string;
    errorToLoad: string;
    noDataMessage: string;
    noDataTitle: string;
    managerialPageTitle: string;
    managerialBreadCrumb: string;
    managerialSubtitle: string;
    vsPreviousMonthLabel: string;
    resolutionRateTitle: string;
    resolvedConversationsLabel: string;
    conversationsBySubjectTitle: string;
    subjectColumn: string;
    conversationsColumn: string;
    contactsRankingTitle: string;
    nameColumn: string;
    unreadMessagesColumn: string;
    csatSatisfactionTitle: string;
    csatSatisfactionEvolutionTitle: string;
    slaEvolutionPercentTitle: string;
    slaByQueuePercentTitle: string;
    aiVsHumanPercentTitle: string;
    backlogAverageTitle: string;
    contactsTitle: string;
    attendedContactsLabel: string;
    newContactsLabel: string;
    contactsByTagTitle: string;
    tagColumn: string;
    contactsColumn: string;
    attendantFilter: string;
    monthLabel: string;
    previousMonthButton: string;
    nextMonthButton: string;
    noRatingsLabel: string;
    vsPreviousPeriodLabel: string;
    targetLabel: string;
    managerialNewConversationsTitle: string;
    managerialClosedConversationsTitle: string;
    managerialSlaTitle: string;
    managerialFrtTitle: string;
    managerialTmaTitle: string;
    csatTitle: string;
    aiLabel: string;
    humanLabel: string;
    newLabel: string;
    closedLabel: string;
    conversationsEvolutionTitle: string;
    slaEvolutionTitle: string;
    csatEvolutionTitle: string;
    entriesByHourTitle: string;
    insideBusinessHoursLabel: string;
    outsideBusinessHoursLabel: string;
    entriesByWeekdayTitle: string;
    aiVsHumanEvolutionTitle: string;
    managerialBacklogTitle: string;
    slaByQueueTitle: string;
    unreadRankingTitle: string;
    queueColumn: string;
    slaColumn: string;
    targetColumn: string;
    variationColumn: string;
    rankColumn: string;
    quantityColumn: string;
    weekdayShortNames: string;
  };

export const SERVICE_DASHBOARD_MESSAGES: ServiceDashboardMessages = {
  pageTitle: "Operações de Atendimento",
  pageSubtitle: "",
  breadCrumbTitle: "Dashboard",
  operationalBreadCrumb: "Operacional",
  refreshButton: "Atualizar",
  applyFiltersButton: "Aplicar filtros",
  fullscreenButton: "Tela cheia",
  lastUpdatedLabel: "Atualizado às",
  liveLabel: "Ao vivo",
  realtimeLabel: "Tempo real",
  todayLabel: "Hoje",
  filtersButton: "Filtros",
  clearFiltersButton: "Limpar",
  sectionPulseTitle: "Pulso da operação",
  sectionPulseCaption: "Volume de conversas em tempo real",
  sectionSlaTitle: "SLA e tempos",
  sectionSlaCaption: "Velocidade de resposta e atendimento",
  sectionQueuesTitle: "Backlog e filas",
  sectionQueuesCaption: "Onde a operação está represada",
  sectionDistributionTitle: "Distribuição",
  sectionDistributionCaption: "Como as conversas estão divididas",
  sectionTrendTitle: "Tendências",
  sectionTrendCaption: "Entrada de conversas e origem do atendimento",
  totalLabel: "Total",
  autoRefreshHint: "Atualiza a cada 10 minutos",
  autoRefreshLabel: "Atualização automática",
  queueFilter: "Fila",
  tagFilter: "Tag",
  workflowFilter: "Workflow",
  activeConversationsTitle: "Conversas ativas",
  newConversationsTitle: "Novas conversas hoje",
  closedConversationsTitle: "Encerradas hoje",
  unansweredConversationsTitle: "Conversas sem resposta",
  unreadMessagesTitle: "Mensagens não lidas",
  frtTitle: "Tempo médio 1ª resposta",
  slaTitle: "SLA de resposta (meta da fila)",
  tmaTitle: "Tempo médio de atendimento",
  backlogTitle: "Backlog por tempo de abertura",
  conversationsByQueueTitle: "Conversas por fila",
  queueCapacityTitle: "Capacidade das filas",
  conversationsByWorkflowTitle: "Conversas por workflow",
  conversationsByAttendantTitle: "Conversas por atendente (abertas)",
  unreadByQueueTitle: "Ranking fila (mensagens não lidas)",
  aiVsHumanTitle: "IA x Humano",
  conversationsByHourTitle: "Entrada de conversas por hora",
  attendantsLabel: "Atendentes",
  openConversationsLabel: "Abertas",
  conversationsPerAttendantLabel: "Por atendente",
  conversationsPerAttendantUnit: "conv/atend",
  conversationsTitle: "Conversas",
  interactionsTitle: "Interações",
  averageInteractionsPerConversationTitle: "Média de interações",
  attendantPerformanceTitle: "Evolução dos atendimentos por mês",
  attendantPerformanceSubtitle: "Comparativo do atendimento agente x atendentes",
  monthlyAttendantsTitle: "Atendentes do mês",
  attendantHeader: "Atendente",
  totalHeader: "Total",
  monthColumn: "Mês",
  attendantColumn: "Atendente",
  attendantCountColumn: "Contagem de atendentes",
  totalColumn: "Total",
  today: "Hoje",
  currentMonth: "Mês atual",
  currentYear: "Ano atual",
  lastDay: "Último dia",
  lastMonth: "Último mês",
  lastYear: "Último ano",
  errorToLoad: "Erro ao carregar dados",
  notFoundAlt: "Dado não encontrado",
  noDataMessage: "Não há dados disponíveis para os filtros selecionados",
  noDataTitle: "Nenhum dado encontrado",
  managerialPageTitle: "Dashboard Gerencial",
  managerialBreadCrumb: "Gerencial",
  managerialSubtitle: "Visão estratégica da operação no período selecionado",
  vsPreviousMonthLabel: "vs período anterior",
  resolutionRateTitle: "Taxa de resolução",
  resolvedConversationsLabel: "conversas resolvidas",
  conversationsBySubjectTitle: "Conversas por assunto",
  subjectColumn: "Assunto",
  conversationsColumn: "Conversas",
  contactsRankingTitle: "Ranking de contatos",
  nameColumn: "Nome",
  unreadMessagesColumn: "Mensagens não lidas",
  csatSatisfactionTitle: "CSAT (Satisfação)",
  csatSatisfactionEvolutionTitle: "Evolução do CSAT (Satisfação)",
  slaEvolutionPercentTitle: "Evolução do SLA de resposta (%)",
  slaByQueuePercentTitle: "SLA de resposta por fila (%)",
  aiVsHumanPercentTitle: "Evolução IA x Humano (%)",
  backlogAverageTitle: "Backlog por tempo de abertura (média no período)",
  contactsTitle: "Contatos",
  attendedContactsLabel: "Atendidos",
  newContactsLabel: "Novos",
  contactsByTagTitle: "Contatos por Tags",
  tagColumn: "Tag",
  contactsColumn: "Contatos",
  attendantFilter: "Atendente",
  monthLabel: "Mês",
  previousMonthButton: "Mês anterior",
  nextMonthButton: "Próximo mês",
  noRatingsLabel: "Sem dados",
  vsPreviousPeriodLabel: "vs período anterior",
  targetLabel: "Meta",
  managerialNewConversationsTitle: "Novas conversas",
  managerialClosedConversationsTitle: "Conversas encerradas",
  managerialSlaTitle: "SLA de resposta",
  managerialFrtTitle: "Tempo médio 1ª resposta",
  managerialTmaTitle: "Tempo médio atendimento",
  csatTitle: "CSAT",
  aiLabel: "IA",
  humanLabel: "Humano",
  newLabel: "Novas",
  closedLabel: "Encerradas",
  conversationsEvolutionTitle: "Evolução das conversas",
  slaEvolutionTitle: "Evolução do SLA",
  csatEvolutionTitle: "Evolução do CSAT",
  entriesByHourTitle: "Entrada por hora",
  insideBusinessHoursLabel: "Dentro do horário",
  outsideBusinessHoursLabel: "Fora do horário",
  entriesByWeekdayTitle: "Entrada por dia da semana",
  aiVsHumanEvolutionTitle: "Evolução IA x Humano",
  managerialBacklogTitle: "Backlog por tempo de abertura",
  slaByQueueTitle: "SLA por fila",
  unreadRankingTitle: "Ranking de filas por mensagens não lidas",
  queueColumn: "Fila",
  slaColumn: "SLA",
  targetColumn: "Meta",
  variationColumn: "Variação",
  rankColumn: "#",
  quantityColumn: "Qtde",
  weekdayShortNames: "Seg,Ter,Qua,Qui,Sex,Sáb,Dom",
  ...SIDEBAR_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};

export default SERVICE_DASHBOARD_MESSAGES;
